var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sort-img" },
    [
      _vm._l(_vm.imgs, function (url, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "sort-img-item",
            attrs: { draggable: "true" },
            on: {
              dragstart: function ($event) {
                return _vm.handleDragStart($event, index)
              },
              dragover: function ($event) {
                $event.preventDefault()
                return _vm.handleDragOver($event, url)
              },
              dragenter: function ($event) {
                return _vm.handleDragEnter($event, index)
              },
              dragend: function ($event) {
                return _vm.handleDragEnd($event, url)
              },
            },
          },
          [
            _c("el-image", {
              staticClass: "sort-img-item-image",
              attrs: { src: url, "preview-src-list": _vm.imgs },
            }),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-error btndel",
              on: {
                click: function ($event) {
                  return _vm.handleRemove(index)
                },
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }